import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { DataTable } from '../../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../../IAdminPageProperties';
import { UserAdminDomain } from './store/UserAdminDomain';

export interface UserAdminTableProperties extends IAdminPageProperties { }

export const UserAdminTable = observer(({ layoutDomain }: UserAdminTableProperties) => {
  const [domain] = useState<UserAdminDomain>(new UserAdminDomain(layoutDomain));

  return <DataTable dataTableDomain={domain} />;
});
